import axios from 'axios';
import config from '../constants/config';
import { toastError } from './toast';
import { GET_SCALE_REMOTE_REQUEST, SET_SCALE_REMOTE } from '../constants/action-types';
import { getScaleMachineDetails, setScaleMachineDetails } from '../helpers/session';

const toastOptions = { position: "top-left" };
const baseURL = config.remotescalesocket.API_URL;

export const getRemoteScaleRequest = (data) => ({ type: GET_SCALE_REMOTE_REQUEST, payload: data });
export const setRemoteScale = (data) => ({ type: SET_SCALE_REMOTE, payload: data });

export const getRemoteScaleInfo = (reqParams, cb = null) => dispatch => {
    dispatch(getRemoteScaleRequest());
    const baseURLV1 = (reqParams && reqParams.scaleURL) ? reqParams.scaleURL : null;
    const params = {
        method: 'GET', headers: { 'content-type': 'application/json' }
    };

    const getData = axios(`${baseURLV1 ? baseURLV1 : baseURL}/weight.json`, params);
    getData.then(async (res) => {
        if (res && res.status && res.status === 200) {
            await dispatch(setRemoteScale(res.data));
            if (cb) cb(true, res.data);
        } else {
            dispatch(setRemoteScale({}));
            if (cb) cb(false);
        }

    }).catch(_ex => {
        //dispatch(toastError(ex.message, toastOptions));
        dispatch(setRemoteScale({}));
        setScaleMachineDetails()
        if (cb) cb(false);
    });

};

export const saveScaleInfo = (data, cb = null) => dispatch => {
    const scaleDevice = getScaleMachineDetails();
    const baseURLV1 = (scaleDevice && scaleDevice.scaleAPIURL) ? scaleDevice.scaleAPIURL : null;

    const params = {
        method: 'PUT',
        headers: { 'content-type': 'application/json' },
        data
    };

    const saveInfo = axios(`${baseURLV1 ? baseURLV1 : baseURL}/weight/save`, params);
    saveInfo.then(res => {
        if (res && res.data && res.data.status === 'success') {
            if (cb) cb(true);
        } else if (res && res.data && res.data.status === 'error') {
            if (res.data.message) dispatch(toastError(res.data.message, toastOptions));
            if (cb) cb(false);
        } else {
            if (cb) cb(false);
        }

    }).catch(ex => {
        dispatch(toastError(ex.message, toastOptions));
        if (cb) cb(false);
    });

};